import React from "react";
import GameBoard from './components/GameBoard';

function App() {
  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h1>Game Test</h1>
      <GameBoard />
    </div>
  );
}

export default App;
